<template>
  <label class="link mb-0" :class="{ outline }">
    <input
      ref="fileInput"
      type="file"
      :accept="accept"
      @change="handleChange"
    />
    <i :class="[`fa ${icon}`]"></i>
    <span v-if="text" class="ml-1">{{ text }}</span>
  </label>
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
      default: "fa-upload"
    },
    text: {
      type: String,
      default: ""
    },
    accept: {
      type: String,
      default: "*"
    },
    outline: {
      type: Boolean,
      default: false
    }
  },
  emits: ["change"],
  methods: {
    clearInput() {
      this.$refs.fileInput.value = null;
    },
    handleChange(e) {
      e.stopPropagation(); // prevent native event from bubbling
      this.$emit("change", e);
      this.clearInput();
    }
  }
};
</script>

<style lang="scss" scoped>
input[type="file"] {
  display: none;
}
.outline {
  border: solid 1px var(--gray-border-color);
  border-radius: 3px;
  padding: 5px 10px;
  background: var(--lightblue);
  color: #fff !important;
  text-decoration: none !important;
  &:hover {
    background: darken(#027db4, 10%);
  }
}
</style>
